/** 直リンクとアプリ内遷移の両方で、戻る履歴をループさせないための純粋判定。 */

export interface BackFallbackState {
  fallbackBackTo: string;
}

export interface BackNavigation {
  to: string | number;
  replace?: boolean;
  state?: BackFallbackState;
}

function fallbackFrom(state: unknown): string | null {
  if (typeof state !== 'object' || state === null || !('fallbackBackTo' in state)) return null;
  const value = (state as { fallbackBackTo?: unknown }).fallbackBackTo;
  return typeof value === 'string' && value.startsWith('/') ? value : null;
}

/**
 * アプリ内遷移なら履歴を1つ戻る。直リンクなら現在の項目を置換し、置換先にも
 * 次のフォールバックを渡すことで「編集 ↔ 閲覧」の戻るループを作らない。
 */
export function resolveBackNavigation(
  locationKey: string,
  locationState: unknown,
  directBackTo: string,
  destinationFallback?: string,
): BackNavigation {
  const inheritedFallback = fallbackFrom(locationState);
  if (inheritedFallback) {
    return { to: inheritedFallback, replace: true };
  }
  if (locationKey === 'default') {
    return {
      to: directBackTo,
      replace: true,
      ...(destinationFallback
        ? { state: { fallbackBackTo: destinationFallback } }
        : {}),
    };
  }
  return { to: -1 };
}
